<template>
    <div>
        <div class="vote-journal-analysis">
            <div class="analysis">
                <div class="title">{{journalTitle}}分析报告</div>

                <div class="journal-info">
                    <div class="cover">
                        <img v-if="journalInfo.imgUrl" :src="imgSiteUrl+journalInfo.imgUrl" alt="">
                    </div>
                    <div class="info">
                        <div class="rate">
                            推荐指数:<a-rate :value="getRate(journalInfo.score)" allow-half disabled />{{journalInfo.score}}%
                        </div>
                        <h2>相关论文：</h2>
                        <div class="related">本刊近三年收录相似论文<span>{{journalInfo.sim_articles_num}}篇</span>，其中包含两个及以上相同核心主题词的文章<span>{{journalInfo.topic_least2_article_count}}篇</span></div>
                        <a-button type="primary" @click="tips">导出报告</a-button>
                    </div>
                    <div class="clear"></div>
                </div>

                <div class="base-knowledge">
                    <div class="name">论文核心知识点</div>
                    <div class="list">
                        <div class="item"><span class="label">您的稿件标题</span>{{voteCondition.title}}</div>
                        <div class="item"><span class="label">您的稿件摘要</span>{{voteCondition.summary}}</div>
                        <div class="item"><span class="label">您的稿件核心知识点</span></div>
                    </div>
                </div>

                <div class="topic-analysis">
                    <div class="name">本刊核心主题词分析</div>
                    <div class="chart" ref="chartDom"></div>
                    <div class="table">
                        <a-table :dataSource="topics" :rowKey="record=>record.sort" :columns="columns" :pagination="false" />
                    </div>
                </div>
                

                <div class="topic-analysis">
                    <div class="name">本刊相似论文</div>
                    <div class="table">
                        <a-table :dataSource="journalLikeMap" :rowKey="record=>record.art_id" :pagination="false">
                            <a-table-column key="sims" title="匹配度" data-index="sims"></a-table-column>
                            <a-table-column key="title" title="标题" data-index="title"></a-table-column>
                            <a-table-column key="topic_name" title="主题词" data-index="topic_name">
                                <template #default="{ text: tags }">
                                    <a-tag color="red" style="margin-bottom:10px" v-for="item in tags" :key="item">{{item}}</a-tag>
                                </template>
                            </a-table-column>
                            <a-table-column key="author" title="作者" data-index="author"></a-table-column>
                        </a-table>
                    </div>
                </div>
            </div>
            <div class="rec">
                <div class="block-title">
                    <span>论文推荐</span>
                </div>
                <div class="title-line"></div>
                <div class="list">
                    <div class="item" v-for="item in recList" :key="item.id">
                        <router-link :to="{path:'/essay_detail',query:{id:item.id,type:2}}" target="_blank">{{item.title}}</router-link>
                        <div class="journal">
                            <div class="pic">
                                <img :src="imgSiteUrl+item.jourImgUrl" alt="">
                            </div>
                            《{{item.journalNameZH}}》{{item.editor}}推荐
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, ref, toRefs } from "vue";
import { useRoute } from "vue-router";
import config from "../../until/configs";
import Http from "../../until/http";
import { getSessionItem, messageTips } from "../../until/tools";
import * as Echart from 'echarts';
const columns = [
    {
        title: '排序',
        dataIndex: 'sort',
        key: 'sort',
        align:'center'
    },
    {
        title: '近3年',
        dataIndex: 'threeName',
        key: 'threeName',
        align:'center'
    },
    {
        title: '出现频次',
        dataIndex: 'threeFreq',
        key: 'threeFreq',
        align:'center'
    },
    {
        title: '近5年',
        dataIndex: 'fiveName',
        key: 'fiveName',
        align:'center'
    },
    {
        title: '出现频次',
        dataIndex: 'fiveFreq',
        key: 'fiveFreq',
        align:'center'
    },
];

const echartsOption = {
    legend: {
        data: ['数量'],
        left: 'right',
        show:false
    },
    polar: {},
    tooltip: {
        formatter: function (params) {
            return params.name+'：'+params.value[2];
        }
    },

    angleAxis: {
        type: 'category',
        data: [],
        boundaryGap: false,
        splitLine: {
            show: true,
            lineStyle: {
                color: '#666',
                type: 'dashed'
            }
        },
        axisLine: {
            show: false,
        }
    },
    radiusAxis: {
        type: 'category',
        data: ['近三年','近五年'],
        axisLine: {
            show: false
        },
        axisLabel: {
            rotate: 45
        }
    },
    series: [{
        name: '数量',
        type: 'scatter',
        coordinateSystem: 'polar',
        right: '3%',
        symbolSize: function (val) {
            return val[2] * 4;
        },
        data: [],
        animationDelay: function (idx) {
            return idx * 10;
        }
    }]
}
export default defineComponent({
    setup() {
        let route = useRoute();

        const journalTitle = computed(()=>{
            return route.query.name;
        });

        const voteCondition = ref(getSessionItem('voteCondition'));

        const state = reactive({
            journalInfo:{},
            imgSiteUrl:config.imgSiteUrl,
            topics:[],
            journalLikeMap:[],
            recList:[]
        })

        let chartDom = ref(null);

        const getRate = (value)=>{
            var result = 0;
            if(typeof value === 'string') {
                result = Math.round(parseFloat(value)/10)/2;
            } else {
                result = Math.random(value/10)/2;
            }
            return result;
        }

        const tips = ()=>{
            messageTips('功能开发中~',2);
        }
        
        onMounted(()=>{
            
            document.title = '投稿分析-'+config.siteTitle;

            let params = getSessionItem('voteCondition');
            params.journalTitle = journalTitle.value;
            Http.voteAnalysisInfo(params).then(res=>{
                if(res) {
                    if(res.success) {
                        Object.assign(state,{
                            journalInfo:res.journalMap,
                            journalLikeMap:res.journalLikeMap.map((item)=>{
                                item.topic_name = item.topic_name.split('；');
                                item.sims = parseFloat(item.sims).toFixed(2)
                                return item;
                            })
                        });
                        if(res.journalKeywordMap) {
                            let arr = [];
                            for(let i=0;i<res.journalKeywordMap.five.length;i++) {
                                arr.push({
                                    sort:(i+1),
                                    threeName:res.journalKeywordMap.three[i].topic_name,
                                    fiveName:res.journalKeywordMap.five[i].topic_name,
                                    threeFreq:res.journalKeywordMap.three[i].topic_count,
                                    fiveFreq:res.journalKeywordMap.five[i].topic_count
                                })
                            }

                            let words = [];
                            var data = [];
                            if(res.journalKeywordMap.three) {
                                res.journalKeywordMap.three.forEach((item,key)=>{
                                    words.push(item.topic_name);
                                    data.push([0,key,item.topic_count]);
                                });
                            }
                            if(res.journalKeywordMap.five) {
                                res.journalKeywordMap.five.forEach(item=>{
                                    if(words.indexOf(item.topic_name)===-1) {
                                        words.push(item.topic_name);
                                    }
                                });
                                res.journalKeywordMap.five.forEach((item)=>{
                                    var key = words.indexOf(item.topic_name);
                                    data.push([1,key,item.topic_count]);
                                });
                            }
                            echartsOption.angleAxis.data = words;
                            echartsOption.series[0].data = data;
                            var echartsMap = Echart.init(chartDom.value);
                            echartsMap.setOption(echartsOption);

                            Object.assign(state,{
                                topics:arr
                            });
                        }
                    } else {
                        messageTips(res.message,1);
                    }
                }
            });

            Http.getRectEssay().then(res=>{
                if(res.recommendations) {
                    Object.assign(state,{
                        recList:res.recommendations
                    })
                }
            })
        })

        return  {
            journalTitle,
            ...toRefs(state),
            chartDom,
            getRate,
            columns,
            //columns2,
            voteCondition,
            tips
        }
    }
})
</script>
<style lang="scss">
.rate {
    .ant-rate-star:not(:last-child) {
        margin-right: 3px;
    }
}
</style>
<style lang="scss" scoped>
@import '../../scss/vote-analysis.scss';
</style>